import { ROLES } from '@/modules/constants'

export class StandardReportPermissions {
  constructor(user, regions = []) {
    this.user = user
    this.regions = regions || []
  }

  canView(target) {
    const t = this.parse(target)
    if (!t) return false

    switch (this.user.role) {
      case ROLES.ROLE_CZN_TERRITORIAL:
        return this.isOwnCzn(t)
      case ROLES.ROLE_CZN_MANAGER:
      case ROLES.ROLE_REGIONAL_ADMINISTRATOR:
      case ROLES.ROLE_REGIONAL_AGENCY:
        return this.isOwnRegionScope(t)
      case ROLES.ROLE_VNII:
      case ROLES.ROLE_ADMIN:
      case ROLES.ROLE_MINTRUD:
        return true
      default:
        return false
    }
  }

  canEdit(target) {
    const t = this.parse(target)
    if (!t) return false

    switch (this.user.role) {
      case ROLES.ROLE_CZN_TERRITORIAL:
        return this.isOwnCzn(t)
      case ROLES.ROLE_CZN_MANAGER:
      case ROLES.ROLE_REGIONAL_ADMINISTRATOR:
        return t.level === 'czn' && this.isOwnRegionScope(t)
      case ROLES.ROLE_REGIONAL_AGENCY:
        return this.isOwnRegionScope(t)
      case ROLES.ROLE_VNII:
      case ROLES.ROLE_ADMIN:
        return true
      case ROLES.ROLE_MINTRUD:
        return false
      default:
        return false
    }
  }

  /** Вернуть на черновик — только ВТ и АС */
  canReturnToDraft() {
    return this.user.role === ROLES.ROLE_VNII || this.user.role === ROLES.ROLE_ADMIN
  }

  parse(target) {
    if (!target) return null

    const cznId = target.cznId != null && target.cznId !== '' ? Number(target.cznId) : null
    const level = target.level || (cznId != null ? 'czn' : 'region')
    return {
      level,
      regionCode: target.regionCode || null,
      cznId,
    }
  }

  isOwnCzn(t) {
    if (t.level !== 'czn') return false
    if (t.cznId == null) return true
    return t.cznId === this.user.department?.id
  }

  isOwnRegionScope(t) {
    const ownCode = this.user.region?.code
    if (!ownCode) return false
    if (t.regionCode) return t.regionCode === ownCode
    if (t.cznId != null) {
      const region = this.regions.find(r => r.code === ownCode)
      return !!region?.departments?.some(d => d.id === t.cznId)
    }
    return true
  }
}
